import { defineStore } from "pinia";
import { ModalType } from "@/interfaces/ModalType.ts";

interface ModalState {
  shownModals: ModalType[];
}

export const useModalStore = defineStore("modal", {
  state: (): ModalState => ({
    shownModals: [],
  }),

  getters: {
    getShownModals: (state: ModalState) => state.shownModals,
    getShownModalById: (state: ModalState) => (id: string) => state.shownModals.find((modal) => modal.id === id),
  },

  actions: {
    showModal(modal: ModalType) {
      const index = this.shownModals.findIndex((item) => item.id === modal.id);

      if (index === -1) {
        this.shownModals.push(modal);
      }
    },
    hideModal(id: string) {
      const modal = this.getShownModalById(id);

      if (modal) {
        this.shownModals = this.shownModals.filter((modal) => modal.id !== id);
      }
    },
    hideAllModals() {
      this.shownModals = [];
    },
  },
});
